import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedAdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user || !user.is_staff) return <Navigate to="/admin-login" />;
  return children;
};

export default ProtectedAdminRoute;